export default __webpack_public_path__ + "static/media/Aput.e8a89f04.png";